/**
 * ==============
 * Tabs Module 
 * =============
 */

const jfModal = (function () {
  'use strict';

  // configuration
  const config = {
    mainEl: $('section[role="main"]'), // Main app wrapper
    modalContent: '',
    scrolled: 0,
    modalTrigger: $('[data-modaltrigger]'),
    modalContentClass: 'modal--on',
    noScrollClass: 'no-scroll',
    timeout: 300
  };

  const modalOpen = function (clickedButton) {
    const clickedData = $(clickedButton).data('modaltrigger');
    config.modalContent = $(document).find('[data-modalcontent="' + clickedData + '"]');
    config.scrolled = $(window).scrollTop();

    $(config.mainEl).css({
      'position': 'relative',
      'top': -config.scrolled // Makes the window lock the position to where it was scrolled to
    });

    $('html, body').addClass(config.noScrollClass);
    $(config.modalContent).addClass(config.modalContentClass);
  };

  const modalClose = function () {
    $(config.modalContent).removeClass(config.modalContentClass);
    setTimeout(function () {

      $('html, body').removeClass(config.noScrollClass);

      $(config.mainEl).removeAttr('style');
      $(window).scrollTop(config.scrolled);
      config.scrolled = 0;

    }, config.timeout);
  };

  const bindUIActions = function () {

    //Open Modal
    config.modalTrigger.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation(); // This is used so that the event bubbling doesn't happen and doesn't trigger the document click event
      modalOpen($(this));
    });

    //Close Modal on clicking on close button or background
    $(document).on('click', '.modal', function (e) {
      e.preventDefault();
      if ($(e.target).is('.btn--close') || $(e.target).is('.modal')) {
        modalClose();
      }
    });

    //Close Modal on press escape key
    $(document).on('keydown', function (e) {
      if (e.keyCode === 27) {
        modalClose();
      }
    });
  };

  const init = function () {
    bindUIActions();
  };

  return {
    init: init
  }

}());